import { Injectable } from '@angular/core';
import { ModalController } from '../modal-controller/modal-controller.service';
import { ImageLoaderModalComponent } from '../../components/modal/image-loader-modal/image-loader-modal.component';


@Injectable({
  providedIn: 'root'
})
export class ImageLoaderModalController {
  
  constructor(private modalController: ModalController) { }

  create( title:string, imageLoader: {
    onSave: Function
  }) {
    this.modalController.create({
      title,
      content: {
        component: ImageLoaderModalComponent,
        props: imageLoader
      }
    });
  }
  
  present() {
    return this.modalController.present();
  }
}


